import React, { useEffect, useState } from 'react';
import { ColumnApi, GridApi } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import Loading from '$/components/loading/Loading';
import NoDataFound from '$/components/global/noData';
import AhrefWithTarget from '$/components/ahrefWithTarget';
import { DocumentsAdminService } from '$/services';
import * as Bixby from '$/core';
import './index.scss';
import dayjs from 'dayjs';

const PendingApprovalGrid: React.FC<any> = () => {
  const [, setGridApi] = useState(null as GridApi | null);
  const [, setGridColumnApi] = useState(null as ColumnApi | null);
  const [isLoading, setIsLoading] = useState(false);
  const [pendingApprSummaryError, setPendingApprSummaryError] = useState(undefined as string | undefined);
  const [pendingAprovalSummaries, setpendingAprovalSummaries] = useState(
    [] as Bixby.Models.CompanyDocPendingApprovalSummary[]
  );

  useEffect(() => {
    const getTranscriptionsAsync = async () => {
      setIsLoading(true);
      setPendingApprSummaryError(undefined);
      try {
        //call service to get companies with pending docs
        const result = await DocumentsAdminService.getPendingApprovalSummary();
        setpendingAprovalSummaries(result);
      } catch (e: any) {
        setPendingApprSummaryError('Error retrieving pending approval summaries');
      } finally {
        setIsLoading(false);
      }
    };

    getTranscriptionsAsync();
  }, []);

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  if (!Bixby.Utils.isNullOrEmpty(pendingApprSummaryError)) {
    return <p className="error">{pendingApprSummaryError}</p>;
  } else if (isLoading) {
    return <Loading pageLevel />;
  } else {
    return (
      <>
        {pendingAprovalSummaries && !Bixby.Utils.isNullOrEmpty(pendingAprovalSummaries) ? (
          <div className="pending-approval-data-grid">
            <div className="grid_container">
              <div className="grid ag-theme-alpine">
                <AgGridReact
                  onGridReady={onGridReady}
                  rowData={pendingAprovalSummaries}
                  defaultColDef={{
                    flex: 1,
                    minWidth: 100,
                    sortable: true,
                    resizable: true,
                    lockPinned: true,
                  }}
                  rowHeight={32}
                  headerHeight={32}
                  columnDefs={[
                    {
                      field: 'bixbyId',
                      headerName: 'BixbyId',
                      filter: 'agTextColumnFilter',
                      minWidth: 500,
                      pinned: 'left',
                      cellClass: 'align-left',
                    },
                    {
                      field: 'numberOfDocs',
                      headerName: 'Number of Docs',
                      minWidth: 300,
                      pinned: 'left',
                      cellClass: 'align-center',
                    },
                    {
                      field: 'uploadDate',
                      headerName: 'Uploaded Date',
                      filter: 'agDateColumnFilter',
                      minWidth: 300,
                      pinned: 'left',
                      cellClass: 'align-center',
                      valueFormatter: params => dayjs(params.value).format('MM/DD/YYYY'),
                    },
                    {
                      field: 'companyId',
                      headerName: 'Approval Task',
                      filter: 'agTextColumnFilter',
                      maxWidth: 300,
                      cellClass: 'align-center',
                      cellRenderer: (params: any) => {
                        return (
                          <AhrefWithTarget
                            path={`admin/company/${params.value}/document-hosting`}
                            text={'Go to approval'}
                          />
                        );
                      },
                    },
                  ]}></AgGridReact>
              </div>
            </div>
          </div>
        ) : (
          <NoDataFound dataType="pending approval" />
        )}
      </>
    );
  }
};

export default PendingApprovalGrid;
